export const UnitResponsibleRelation = {
   FRIEND: 0,
   CONJUGUE: 1,
   FAMILY: 2,
   SON: 3,
   EMPLOYEE: 4,
   CLIENT: 5,
   OTHER: 6,
}

export const UnitResponsibleRelationText = {
   [UnitResponsibleRelation.FRIEND]: 'common.friend',
   [UnitResponsibleRelation.CONJUGUE]: 'common.spouse',
   [UnitResponsibleRelation.FAMILY]: 'common.family',
   [UnitResponsibleRelation.SON]: 'common.son',
   [UnitResponsibleRelation.EMPLOYEE]: 'common.employee',
   [UnitResponsibleRelation.CLIENT]: 'common.client',
   [UnitResponsibleRelation.OTHER]: 'common.other',
}

export const UnitResponsibility = {
   NOT_RESPONSIBLE: 0,
   RESPONSIBLE: 1,
   NEEDS_AUTHORIZATION: 2,
}

export const UnitResponsibilityText = {
   [UnitResponsibility.NOT_RESPONSIBLE]: 'common.notResponsible',
   [UnitResponsibility.RESPONSIBLE]: 'common.responsible',
   [UnitResponsibility.NEEDS_AUTHORIZATION]: 'common.needsAuthorization',
}